import styled from "styled-components";

export const ArticleRow = styled.tr`
  display: flex;
  flex-wrap: wrap;
  position: relative;

  :nth-child(even) {
    background: ${({ theme }) => theme.light};
  }

  @media (min-width: 480px) {
    display: table-row;
  }

  & td {
    padding: 5px;
    flex: 40%;
  }

  // Title/name of article
  & td:nth-child(3) {
    flex: 100%;
  }

  & .show-on-mobile {
    display: inline-block;

    &::after {
      white-space: pre;
      content: " ";
    }

    @media (min-width: 480px) {
      display: none;
    }
  }
`;

export const ThumbnailTd = styled.td`
  display: none;

  @media (min-width: 480px) {
    display: table-cell;
  }
`;

export const Thumbnail = styled.img`
  width: 75px;
`;

export const QuantityTd = styled.td`
  text-align: right;

  @media (min-width: 480px) {
    text-align: left;
  }
`;

export const ArticleNumber = styled.span`
  display: none;

  @media (min-width: 480px) {
    display: block;
  }
`;

export const AttributeContainer = styled.div`
  display: flex;

  :nth-child(even) {
    background: ${({ theme }) => theme.light};
  }
`;

export const AttributeText = styled.span`
  padding: 10px;
  flex: 1;
`;

export const ShowMore = styled.td`
  display: block;
  flex: 100% !important;
  padding: 10px 0px;
  cursor: pointer;
  font-size: 14px;
  
  @media (min-width: 480px) {
    display: none;
  }
`;

export const PriceContainer = styled.div`
  display: block;

  @media (min-width: 375px) {
    white-space: nowrap;
  }
`;

export const ExpandedAttributes = styled.tr`
  display: flex;

  & td {
    flex: 1;
  }

  @media (min-width: 480px) {
    display: table-row;
  }
`;

export const ExpandTd = styled.td`
  display: none;

  @media (min-width: 480px) {
    text-align: center;
    display: table-cell;
  }
`;

export const DiscountedPrice = styled.span`
  color: ${({ theme }) => theme.discount};
  margin-right: 10px;
`;

export const OrdinaryPrice = styled.span`
  display: inline-block;
  text-decoration: line-through;

  @media (min-width: 480px) {
    display: inline-block;
  }
`;
